import { i18nMap } from '@/data/translationMapper';

export function translateI18nValues<T>(data: T, lang: 'en' | 'it' | string): T {
  if (typeof data === 'string') {
    if (data.startsWith('i18n') && i18nMap[data]) {
      return i18nMap[data][lang] as T;
    }
    return data as T;
  }

  if (Array.isArray(data)) {
    return data.map((item) => translateI18nValues(item, lang)) as T;
  }

  if (data !== null && typeof data === 'object') {
    const result: any = {};
    for (const key in data) {
      result[key] = translateI18nValues((data as any)[key], lang);
    }
    return result;
  }

  // number, boolean, null, undefined
  return data;
}
